import React from 'react';
import styled from 'styled-components';
import { OfflineBar, Box, cssMixins } from '@zen-common/components-base';
import { useOfflineStatus } from '@zen/common-react-hooks';
import { SettingsStore } from '@zen/common-app-parts';
import MainNav from '../navs/MainNav';
import TestnetBar from '../TestnetBar/TestnetBar';

export default function MainLayout({ children }) {
  return (
    <PageAlignment>
      <PageItem>
        <OfflineContainer />
      </PageItem>
      <PageItem>
        <MainNav />
      </PageItem>
      <PageItem css={cssMixins.showOnMobile()}>
        <TestnetBarContainer />
      </PageItem>
      <MainContentWrapper>{children}</MainContentWrapper>
      <PageItem css={cssMixins.showOnDesktop()}>
        <TestnetBarContainer />
      </PageItem>
    </PageAlignment>
  );
}

const PageAlignment = styled(Box)`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const PageItem = styled(Box)`
  flex-grow: 0;
`;

const MainContentWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: auto;
`;

const OfflineContainer = () => {
  const { offline } = useOfflineStatus();

  return offline ? <OfflineBar /> : null;
};

const TestnetBarContainer = () => {
  const {
    state: {
      settings: { oracleUrl },
    },
  } = SettingsStore.useStore();

  return !!oracleUrl && oracleUrl.includes('test') ? <TestnetBar /> : null;
};
